import React, { Component, PropTypes } from 'react';
import Paper from 'material-ui/Paper';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import Avatar from 'material-ui/Avatar';
import CircularProgress from 'material-ui/CircularProgress';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import pluralize from 'pluralize';

const styles = {
  content: {
    margin: '1em',
    textAlign: 'left',
    padding: '1em',
    borderRadius: '10px !important',
  },
  header: {
    fontSize: '1em',
    marginBottom: '1em',
  },
  contactList: {},
  contact: {
    display: 'flex',
    padding: '1em',
    justifyContent: 'space-between',
  },
  avatar: {
    border: 'solid 1px #bbb',
    cursor: 'pointer',
    flex: '0 0 auto',
    left: '0 !important',
    position: 'relative !important',
    top: 'inherit !important',
  },
  contactDetails: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    paddingLeft: '1em',
    fontSize: '1em',
  },
  contactName: {},
  email: {
    fontSize: '0.9em',
  },
  type: {
    fontSize: '0.9em',
  },
  phone: {
    fontSize: '0.9em',
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

class Contacts extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { classes, contacts, contactsLoading, contactsLoaded } = this.props;
    const whatToShow = (() => {
      if (contactsLoading) return 'loading';
      if (contactsLoaded) return 'loaded';
      return 'errored';
    })();
    return (
      <Paper className={classes.content}>
        { whatToShow === 'loaded' ? <div className={classes.header}>{pluralize('Contact', contacts.length)}</div> : undefined }
      {{
        loading: (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
        ),
        errored: (
            <div className={classes.loading}>
              <RefreshIndicator
                percentage={80}
                size={60}
                left={0}
                top={0}
                color="red"
                status="ready"
                style={styles.refresh}
              />
            </div>
        ),
        loaded: (
          <div className={classes.contactList}>
          {contacts.map(({ name = '?', type, phone, fax, email, avatarUrl }, index) => (
            <div className={classes.contact} key={index}>
              <Avatar
                className={classes.avatar}
                {...(avatarUrl) ? ({ src: avatarUrl }) : {} }
              >
                {avatarUrl ? null : (name || '?').replace(/undefined/g, '')[0] || '👤'}
              </Avatar>
              <div className={classes.contactDetails}>
                { Boolean(name) ? <div className={classes.contactName}>{name.replace(/undefined/g, '')}</div> : undefined }
                { Boolean(type) ? <div className={classes.type}>{type}</div> : undefined }
                { Boolean(email) ? <div className={classes.email}>✉️ <a href={`mailto:${email}`}>{email}</a></div> : undefined }
                { Boolean(phone) ? <div className={classes.phone}>📞 <a href={`tel:${phone}`}>{phone}</a></div> : undefined }
                { Boolean(fax) ? <div className={classes.phone}>📠 {fax}</div> : undefined }
              </div>
            </div>
          ))}
        </div>),
      }[whatToShow]}
      </Paper>
    );
  }
}

Contacts.propTypes = {
  classes: PropTypes.object,
  contacts: PropTypes.array,
  contactsLoaded: PropTypes.bool,
  contactsLoading: PropTypes.bool,
};

const select = ({ partnerDetails: store }) => ({
  contacts: store.contacts,
  contactsLoading: store.contactsLoading,
  contactsLoaded: store.contactsLoaded,
});

export default connect(select, {})(injectSheet(styles)(Contacts));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/contacts.jsx